import PATHS from './paths';

const tenDLCRoutes = [

    {
        path: '/',
        redirect: PATHS.SMS_REGISTRATION
    },
    {
        path: PATHS.SMS_REGISTRATION,
        name: 'SmsRegistration',
        components: {
            default: () => import(/* webpackChunkName: 'sms-registration' */ '../components/smsRegistrationComponents/SmsRegistration.vue'),
        },
        meta: {
            title: 'Campaign View',
        },
    },
    {
        path: PATHS.CREATE_CAMPAIGN,
        name: 'CreateCampaign',
        components: {
            default: () => import(/* webpackChunkName: 'campaigns-create' */ '../components/campaigns/createCampaign/CreateCampaign.vue'),
            tips: () => import(/* webpackChunkName: 'campaigns-create' */ '../components/campaigns/createCampaign/CreateCampaignTips.vue'),
        },
        meta: {
            title: 'SMS: Create Campaign',
            hasTips: true,
        },
    },
    {
        path: PATHS.BRANDS,
        name: 'Brands',
        components: {
            default: () => import(/* webpackChunkName: 'brands' */ '../components/brands/Brands.vue'),
            tips: () => import(/* webpackChunkName: 'brands' */ '../components/brands/BrandsTips.vue'),
        },
        meta: {
            title: 'SMS: Brands and Campaigns',
            hasTips: true,
        },
    },
    {
        path: PATHS.CREATE_BRAND,
        name: 'CreateBrand',
        components: {
            default: () => import(/* webpackChunkName: 'brands-create' */ '../components/brands/CreateBrand.vue'),
            tips: () => import(/* webpackChunkName: 'brands-create' */ '../components/brands/CreateBrandTips.vue'),
        },
        meta: {
            title: 'SMS: Create Brand',
            hasTips: true,
        },
    },
    {
        path: PATHS.BRAND_PREVIEW,
        name: 'BrandPreview',
        component: () => import(/* webpackChunkName: 'brands-view' */ '../components/brands/BrandPreview.vue'),
        meta: {
            title: 'SMS: Brand Preview',
        },
    },
    {
        path: PATHS.BRAND_VIEW,
        name: 'BrandView',
        component: () => import(/* webpackChunkName: 'brands-view' */ '../components/brands/BrandView.vue'),
        meta: {
            title: 'Brand View',
        },
    },
    {
        path: PATHS.CAMPAIGN_VIEW,
        name: 'CampaignView',
        components: {
            default: () => import(/* webpackChunkName: 'campaign-view' */ '../components/campaigns/Campaign.vue'),
        },
        meta: {
            title: 'Campaign View',
        },
    }
];

export default tenDLCRoutes;
